import './faq.css';
import { useTranslation } from 'react-i18next';

const FAQ = () => {

    const { t } = useTranslation();

    return (
        <div id="faq" className="faq-wrapper">
            <div className="barmatch-faqs">
                <h4>{t('FAQ_Header')}</h4>
                <details className="question-parent">
                    <summary>{t('FAQQuestion1')}</summary>
                    <div className="faq-answers">
                        {t('FAQAnswer1')}
                    </div>
                </details>
                <details className="question-parent">
                    <summary>{t('FAQQuestion2')}</summary>
                    <div className="faq-answers">
                        {t('FAQAnswer2')}
                    </div>
                </details>
                <details className="question-parent">
                    <summary>{t('FAQQuestion3')}</summary>
                    <div className="faq-answers">
                        {t('FAQAnswer3')}
                    </div>
                </details>
                <details className="question-parent">
                    <summary>{t('FAQQuestion4')}</summary>
                    <div className="faq-answers">
                        {t('FAQAnswer4')}
                    </div>
                </details>
                <details className="question-parent">
                    <summary>{t('FAQQuestion5')}</summary>
                    <div className="faq-answers">
                        {t('FAQAnswer5')}
                    </div>
                </details>
                <details className="question-parent">
                    <summary>{t('FAQQuestion6')}</summary>
                    <div className="faq-answers">
                        {t('FAQAnswer6')}
                    </div>
                </details>
                <details className="question-parent">
                    <summary>{t('FAQQuestion7')}</summary>
                    <div className="faq-answers">
                        {t('FAQAnswer7_1')}
                    </div>
                </details>
            </div>
        </div>
    )
}

export default FAQ